import { Injectable } from "@angular/core";
import { FooterLink } from "@valg-shared/components/footer/footer.component";
import { UrlConfiguration } from "@valg-shared/components/page-dynamic-subheader/page-dynamic-subheader.component";
import { AppConfigService } from "@valg-shared/services/configuration/app.config.service";

@Injectable({
  providedIn: 'root'
})
export class FooterLinkService {
  constructor(readonly appConfigService: AppConfigService<UrlConfiguration>) { }

  getFooterLinks(): FooterLink[] {
    return [
      { titleKey: 'footer.links.accessibility_declaration',
        href: this.appConfigService.config?.accessibilityStatementUrl ?? '', isExternal: true },
      { titleKey: 'footer.links.data_export', href: '/data-eksport', isExternal: true },
      { titleKey: 'footer.links.driftsite',
        href: this.appConfigService.config?.driftSiteUrl ?? '', isExternal: true },
      { titleKey: 'footer.links.privacy_policy', href: '/privatlivspolitik-og-brug-af-data', isExternal: true },
      { titleKey: 'footer.links.sitemap', href: '/sitemap', isExternal: true },
    ];
  }
}
